// extracted by mini-css-extract-plugin
module.exports = {"content":"AuthorizeToLogin_content__d9wJS","sendOtp":"AuthorizeToLogin_sendOtp__1Q874"};